import type { RootState } from '../store';

export const getOperationPreferences = (state: RootState) => state.operationPreferences;

export const getOperationPreferencesStateCode = (state: RootState) =>
  state.operationPreferences.stateCode;

export const getOperationPreferencesIsBeginner = (state: RootState) =>
  state.operationPreferences.isBeginner ?? false;

export const getOperationPreferencesClassPrice = (state: RootState) =>
  state.operationPreferences.preferredClassPriceWeightingFactor;

export const getOperationPreferencesComponentPrice = (state: RootState) =>
  state.operationPreferences.preferredComponentPriceWeightingFactor;

export const getShowPreferredInsuredShare = (state: RootState) =>
  state.operationPreferences.preferredInsuredShare < 1;

export const getOperationPreferencesWithBasis = (state: RootState) =>
  state.operationPreferences.withBasis;

export const getOperationPreferencesWithDeclared = (state: RootState) =>
  state.operationPreferences.withDeclared;
